import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import Panel from '../card/Panel';
import { ID } from '../../../shared/constants/commonConstants';
import { PayerInitialState } from '../../../store/models/payerListModel';
import { GLOBAL_URL } from '../../constants/dataServiceUrl';
const IdCardGuide = (): ReactElement => {
  const searchType = useSelector((state: RootState): any => state.newAdmission.searchType);
  const {payer: {shortName}} = useSelector((state: RootState): PayerInitialState => state.payerList);
  const imageSrc = (ID && ID[shortName] && ID[shortName][searchType]) ? ID[shortName][searchType] : '';
  return (
    <Panel
      className="timeline-scroll"
    >
      <img src={`${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}${imageSrc}`} alt=""
      className="img-fluid" loading="lazy"  key={imageSrc}/>
    </Panel>
  );
};

export default IdCardGuide;
